export default __webpack_public_path__ + "static/media/ant6.7316029c.jpg";